
/* injects from baggage-loader */

const facebookCommentDirective = angular.module('facebookComment.setting', []);

facebookCommentDirective.directive('facebookCommentSetting', [
    '$window', '$timeout', '$compile', '$templateCache', 'ns', '$rootScope', '$filter',
    ($window, $timeout, $compile, $templateCache, ns, $rootScope, $filter) => {
        return {
            restrict: 'A',
            scope: {
                data: '=ngModel'
            },
            link: (scope, element, attrs, ngModel) => {

                const id = attrs.widgetId;
                const widgetElWrapper = angular.element('[data-block-id=' + id + ']').find(ns.widgetWrapperClass);

                // Болванка для работы с настройками виджета FB комментарии
                // console.log({widgetElWrapper});

                scope.accordion = {
                    show_form: false,
                    show_parent_button: false,
                    show_button: false,
                    show_action: false
                };


                let listeners = [];

                listeners.push(scope.$watch('data', (newVal) => {
                    // console.log({newVal});
                }, true));

                scope.$on('$destroy', () => {
                    _.each(listeners, (listener) => {
                        listener();
                    });
                });
            }
        };
    }
]);



// WEBPACK FOOTER //
// ./src/app/editor/modules_settings/facebookComment/facebookComment.directive.js